var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComingSoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.833 0L46.1518 6.41859L53.1937 1.95774L56.2687 9.70578L64.3444 7.63932L64.8746 15.9584L73.1937 16.4886L71.1272 24.5643L78.8753 27.6393L74.4144 34.6812L80.833 40L74.4144 45.3188L78.8753 52.3607L71.1272 55.4357L73.1937 63.5114L64.8746 64.0416L64.3444 72.3607L56.2687 70.2942L53.1937 78.0423L46.1518 73.5814L40.833 80L35.5142 73.5814L28.4723 78.0423L25.3973 70.2942L17.3216 72.3607L16.7914 64.0416L8.47233 63.5114L10.5388 55.4357L2.79075 52.3607L7.2516 45.3188L0.833008 40L7.2516 34.6812L2.79075 27.6393L10.5388 24.5643L8.47233 16.4886L16.7914 15.9584L17.3216 7.63932L25.3973 9.70578L28.4723 1.95774L35.5142 6.41859L40.833 0Z",
    fill: "#BA2E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComingSoon);
export default __webpack_public_path__ + "static/media/coming-soon.b49423b6e0049a0fe9f2fa9f2f4bad8c.svg";
export { ForwardRef as ReactComponent };